// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import billEntity from './entities/bill.json';
import billMenu from '../pages/bill/menu.json';
import billFullForm from '../pages/bill/forms/full.json';
import billContextForm from '../pages/bill/forms/context.json';
import billMiniForm from '../pages/bill/forms/mini.json';
import billLookupForm from '../pages/bill/forms/lookup.json';
import billTableView from '../pages/bill/views/table.json';
import billStagesView from '../pages/bill/views/stages.json';
import billBacklogView from '../pages/bill/views/backlog.json';
import billSplitView from '../pages/bill/views/split.json';
import billCardsView from '../pages/bill/views/cards.json';
import billCalendarView from '../pages/bill/views/calendar.json';
import billDashboardView from '../pages/bill/views/dashboard.json';

/** Тип запису «Законопроєкт» зі сторінками пакета: меню, форми та подання з pages/bill/. */
export const billDefinition: IRecordTypeDefinition = {
  ...billEntity,
  views: assembleViewSet({
      table: billTableView,
      stages: billStagesView,
      backlog: billBacklogView,
      split: billSplitView,
      cards: billCardsView,
      calendar: billCalendarView,
      dashboard: billDashboardView,
  }),
  form: billFullForm,
  forms: { full: billFullForm, context: billContextForm, mini: billMiniForm, lookup: billLookupForm },
  menu: billMenu,
} as IRecordTypeDefinition;
